import { render, staticRenderFns } from "./profile-not-found.vue?vue&type=template&id=5d1ee096&scoped=true&"
import script from "./profile-not-found.vue?vue&type=script&lang=js&"
export * from "./profile-not-found.vue?vue&type=script&lang=js&"
import style0 from "./profile-not-found.vue?vue&type=style&index=0&id=5d1ee096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ee096",
  null
  
)

export default component.exports